import React, { useState } from "react"
import { Button, Modal } from "semantic-ui-react"
import Iframe from "react-iframe"

const JoinNewsletterModal = ({}) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <Modal
      open={modalOpen}
      trigger={
        <Button
          color={"black"}
          size={"massive"}
          content={"Join Newsletter"}
          onClick={() => setModalOpen(true)}
        />
      }
      onClose={() => setModalOpen(false)}
      closeIcon
    >
      <Modal.Content style={{ padding: 0 }}>
        <Iframe
          url="https://cdn.forms-content.sg-form.com/acd26eca-ba4d-11ea-bfba-96e01d6b45fc"
          width="100%"
          height="550px"
          className="myClassname"
          display="initial"
          position="relative"
        />
      </Modal.Content>
    </Modal>
  )
}

export default JoinNewsletterModal
